import { Routes } from '@angular/router';

export const adminOfferRoutes: Routes = [
    {
        path: $localize`:@@adminOfferPath:oferta`,
        loadComponent: () => import('src/app/rokezzz/product/admin/views/product/product.component').then(module => module.RokezzzProductViewComponent),
        data: {
            path: 'admin.offer'
        },
        children: [
            {
                path: $localize`:@@adminOfferProductCategoryArchivedPath:kategorie-produktow-archiwum`,
                loadComponent: () => import('src/app/rokezzz/product/admin/views/product/archive-category/archive-category.component').then(module => module.RokezzzArchiveCategoryViewComponent),
                data: {
                    path: 'admin.offer.product-category-archived',
                    productCategoryFormPath: 'admin.offer.product-category-form'
                }
            },
            {
                path: $localize`:@@adminOfferProductCategoryPath:kategorie-produktow`,
                loadComponent: () => import('src/app/rokezzz/product/admin/views/product/category/category.component').then(module => module.RokezzzCategoryViewComponent),
                data: {
                    path: 'admin.offer.product-category',
                    productCategoryFormPath: 'admin.offer.product-category-form'
                }
            },
            {
                path: $localize`:@@adminOfferProductCategoryPath:formularz-kategorii-produktow`,
                loadComponent: () => import('src/app/rokezzz/product/admin/views/product/category-form/category-form.component').then(module => module.RokezzzCategoryFormViewComponent),
                data: {
                    path: 'admin.offer.product-category-form',
                    productCategoryListPath: 'admin.offer.product-category-archived',
                }
            },
            {
                path: $localize`:@@adminOfferProductCategoryFormPath:formularz-kategorii-produktow` + '/:id',
                loadComponent: () => import('src/app/rokezzz/product/admin/views/product/category-form/category-form.component').then(module => module.RokezzzCategoryFormViewComponent),
                data: {
                    path: 'admin.offer.product-category-form',
                    productCategoryListPath: 'admin.offer.product-category-archived',
                }
            },
            {
                path: $localize`:@@adminOfferProductPath:produkty`,
                loadComponent: () => import('src/app/rokezzz/product/admin/views/product/list/list.component').then(module => module.RokezzzProductListViewComponent),
                data: {
                    path: 'admin.offer.product',
                    productFormPath: 'admin.offer.product-form'
                }
            },
            {
                path: $localize`:@@adminOfferProductPath:produkty-archiwum`,
                loadComponent: () => import('src/app/rokezzz/product/admin/views/product/archive/archive.component').then(module => module.RokezzzArchiveViewComponent),
                data: {
                    path: 'admin.offer.product-archived',
                    productFormPath: 'admin.offer.product-form'
                }
            },
            {
                path: $localize`:@@adminOfferProductFormPath:formularz-produktu`,
                loadComponent: () => import('src/app/rokezzz/product/admin/views/product/product-form/product-form.component').then(module => module.RokezzzProductFormViewComponent),
                data: {
                    path: 'admin.offer.product-form',
                    productListPath: 'admin.offer.product-archived'
                }
            },
            {
                path: $localize`:@@adminOfferProductFormPath:formularz-produktu` + '/:id',
                loadComponent: () => import('src/app/rokezzz/product/admin/views/product/product-form/product-form.component').then(module => module.RokezzzProductFormViewComponent),
                data: {
                    path: 'admin.offer.product-form',
                    productListPath: 'admin.offer.product-archived'
                }
            },
        ]
    },
];
